export interface IPaymentMethod {
  idPaymentMethod: string;
  paymentMethod: string;
  createdAt: string;
  updatedAt: string;
}

export class PaymentMethod {
  idPaymentMethod: string;
  paymentMethod: string;
  createdAt: Date;
  updatedAt: Date;

  constructor(data: IPaymentMethod) {
    this.idPaymentMethod = data.idPaymentMethod;
    this.paymentMethod = data.paymentMethod;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
  }
}
